import { css, jsx } from '@emotion/core';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';

const style = {
  contactContainer: css`
    margin: 0 0 32px;
    @media print {
      display: none;
    }
  `,
  contactList: css`
    list-style: none;
    margin: 1.4rem 0 2rem;
    padding: 0;

    @media ${bp.md} {
      display: flex;
      flex-wrap: wrap;
    }
  `,
  contactItem: css`
    display: block;
    margin: 0 0 2rem;
    padding: 0;

    @media ${bp.md} {
      flex: 1 0 auto;
      margin: 0 4.6rem 2rem 0;
      max-width: calc(100% / 3 - 4.6rem);
      vertical-align: top;
    }
  `,
  contactName: css`
    color: ${colors.primaryBlue};
    letter-spacing: 0;
  `,
  contactTitle: css`
    color: ${colors.secondaryGray};
    font-size: 1.2rem;
    font-weight: 900;
    line-height: 1.66;
    margin: 0.8rem 0 0;
    text-transform: uppercase;
  `,
  contactCompany: css`
    color: ${colors.secondaryGrayDark};
    font-size: 12px;
    line-height: 20px;
    font-weight: 900;
    padding: 1px 14px;
    border-radius: 100px;
    background-color: ${colors.accentGrayUltralight};
    margin-left: -13px;
  `,
};

const ContactLinks = ({ title = '', contacts = [] }) => {
  if (!contacts.length) return null;

  const handleClick = e => {
    e.preventDefault();
    const cards = document.getElementById('contact-cards');
    if (cards) {
      const { top } = cards.getBoundingClientRect();
      window.scrollTo({ top: top - 80, behavior: 'smooth' });
    }
  };

  return (
    <div css={style.contactContainer}>
      {title && (
        <Heading type={3} theme="primaryGray" weight="bolder">
          {title}
        </Heading>
      )}
      <ul css={style.contactList}>
        {contacts &&
          contacts.map(contact => (
            <li css={style.contactItem} key={contact.id}>
              <Heading type={4} weight="bolder">
                <a href={`#contact-${contact.id}`} css={style.contactName} onClick={handleClick}>
                  {contact.fullname}
                </a>
              </Heading>
              <p css={style.contactTitle}>{contact.title}</p>
              {/* 4274 = APCIA Company Id */}
              {contact?.company && contact.companyid !== 4274 ? (
                <p css={style.contactCompany}>{contact.company}</p>
              ) : null}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ContactLinks;
